import React, { useState } from 'react'
import { OverContainer, OverContainerSection, SelectSection } from './styles'
import TechnologySelection from './TechnologySelection'
import { AllTable } from './AllTable'

export function Admin() {
    const [technologyView, setTechnologyView] = useState<string>('Contact Us')
    const handleTableView = (title: string) => {
        setTechnologyView(title)
    }
    return (
        <>
            <OverContainerSection>
                <OverContainer
                    marginTop={['xlarge', 'xlarge', 'xxmedium', 'spacesFull']}
                >
                    <TechnologySelection handleTableView={handleTableView} />
                </OverContainer>
                <SelectSection>
                    <AllTable technologyView={technologyView} />
                </SelectSection>
            </OverContainerSection>
        </>
    )
}
